import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

import Icon from '../../../components/AppIcon';

import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const [animatedElements, setAnimatedElements] = useState([]);

  useEffect(() => {
    // Create floating casino elements
    const elements = [
      { id: 1, type: 'chip', x: 10, y: 20, delay: 0 },
      { id: 2, type: 'card', x: 85, y: 15, delay: 1 },
      { id: 3, type: 'dice', x: 75, y: 70, delay: 2 },
      { id: 4, type: 'chip', x: 15, y: 80, delay: 3 },
      { id: 5, type: 'card', x: 90, y: 50, delay: 4 },
    ];
    setAnimatedElements(elements);
  }, []);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/+917704070169?text=Hello! I would like to know more about Nitin Online Hub premium gaming services.', '_blank');
  };

  const handleTelegramClick = () => {
    window.open('https://t.me/nitinnonlinehub', '_blank');
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 overflow-hidden">
      {/* Royal Pattern Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-repeat" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FFD700' fill-opacity='0.1'%3E%3Cpath d='M30 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20zm0 0c0 11.046 8.954 20 20 20s20-8.954 20-20-8.954-20-20-20-20 8.954-20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      {/* Animated Casino Elements */}
      {animatedElements?.map((element) => (
        <div
          key={element?.id}
          className="absolute animate-float"
          style={{
            left: `${element?.x}%`,
            top: `${element?.y}%`,
            animationDelay: `${element?.delay}s`,
            animationDuration: '4s'
          }}
        >
          {element?.type === 'chip' && (
            <div className="w-12 h-12 bg-gradient-royal rounded-full shadow-royal flex items-center justify-center animate-spin" style={{ animationDuration: '8s' }}>
              <span className="text-white text-xs font-bold">₹</span>
            </div>
          )}
          {element?.type === 'card' && (
            <div className="w-8 h-12 bg-white rounded-sm shadow-royal flex items-center justify-center transform rotate-12">
              <Icon name="Spade" size={16} color="#DC143C" />
            </div>
          )}
          {element?.type === 'dice' && (
            <div className="w-10 h-10 bg-white rounded-md shadow-royal flex items-center justify-center">
              <div className="grid grid-cols-2 gap-1">
                <div className="w-1 h-1 bg-black rounded-full"></div>
                <div className="w-1 h-1 bg-black rounded-full"></div>
                <div className="w-1 h-1 bg-black rounded-full"></div>
                <div className="w-1 h-1 bg-black rounded-full"></div>
              </div>
            </div>
          )}
        </div>
      ))}
      {/* Main Content */}
      <div className="relative z-10 flex items-center min-h-screen pb-24">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Royal Crest */}
            <div className="mb-8 flex justify-center">
              <div className="relative">
                <div className="w-28 h-28 bg-white rounded-full flex items-center justify-center shadow-royal border-4 border-white">
                  <img
                    src="/assets/images/logo.png" // Adjust path if needed
                    alt="Nitin Online Hub Logo"
                    className="h-24 w-24 object-contain"
                    style={{ borderRadius: '50%' }}
                  />
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent rounded-full animate-pulse-golden flex items-center justify-center">
                  <Icon name="Star" size={12} color="white" />
                </div>
              </div>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-heading font-bold mb-6 leading-tight">
              <span className="text-gradient-royal">Nitin Online Hub</span>
              <br />
              <span className="text-white">& Nitin Online Book</span>
              <br />
              <span className="text-gradient-royal">Official Gaming Experience</span>
            </h1>

            {/* Subheadline */}
            <p className="text-xl sm:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto font-body">
              Welcome to the official source for Nitin Online Hub and Nitin Online Book. This is your trusted entry point for secure login, easy sign-up, and verified app downloads, backed by genuine 24/7 WhatsApp support and fast withdrawals.
            </p>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center items-center gap-6 mb-12">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Users" size={20} color="#FFD700" />
                <span className="text-white font-medium">10,000+ Players</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Zap" size={20} color="#34C759" />
                <span className="text-white font-medium">Instant Payouts</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Shield" size={20} color="#4169E1" />
                <span className="text-white font-medium">100% Secure</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
              <Button
                variant="default"
                size="lg"
                onClick={handleWhatsAppClick}
                icon={<FaWhatsapp size={20} />}
                iconPosition="left"
                
                className="bg-gradient-royal hover:shadow-glow animate-pulse-golden hover:animate-none text-lg px-8 py-4"
              >
                <FaWhatsapp size={20} className="text-green-500" />
                Get ur Gaming Id
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                onClick={handleTelegramClick}
                iconName="Send"
                iconPosition="left"
                className="border-primary text-primary hover:bg-primary hover:text-white text-lg px-8 py-4"
              >
                Join Telegram VIP
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-bold text-gradient-royal mb-2">₹50L+</div>
                <div className="text-gray-400 text-sm">Daily Winnings</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gradient-royal mb-2">24/7</div>
                <div className="text-gray-400 text-sm">WhatsApp Support</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gradient-royal mb-2">50+</div>
                <div className="text-gray-400 text-sm">Premium Games</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gradient-royal mb-2">5 Min</div>
                <div className="text-gray-400 text-sm">Instant Withdrawal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={32} color="#FFD700" />
      </div>
    </section>
  );
};

export default HeroSection;